<template>
  <div class="row">
    <div class="col-md-2"  v-if="!book_accession.is_available && book_accession.user_full_name">

        <v-avatar
                v-if="book_accession.user_image"
                class="profile"
                color="grey"
                size="164"
                tile
                rounded
        >
            <v-img :src="book_accession.user_image"></v-img>
        </v-avatar>

    </div>
    <div class="col-md-9 ml-6"  v-if="!book_accession.is_available && book_accession.user_full_name">
                 <span>

                      <h5>
                        {{ book_accession.user_id_card_no?book_accession.user_id_card_no+' - ':'' }}
                        {{ book_accession.personal_id?book_accession.personal_id:'' }}
                      </h5>
                      <h5>{{ book_accession.user_full_name }}</h5>
                   <p>
                     <span>{{ book_accession.user_phone }}, {{ book_accession.user_email }}</span><br>
                     <span>{{ book_accession.user_phone }}, {{ book_accession.user_email }}</span><br>
                     <!--                      <span v-if="user.setting && user.setting.academic_year">{{ user.setting.academic_year }}, </span>-->
                      <span v-if="book_accession.academic_year ">{{ book_accession.academic_year }}</span><br>
                      <span v-if="book_accession.program ">{{ book_accession.program }}</span><br>
                      <span v-if="book_accession.grade ">{{ book_accession.grade + " - " }}</span>
                      <span v-if="book_accession.class ">{{ book_accession.class }}</span>

                   </p>
                 </span>
    </div>
    <div class="col-12">
      <v-btn x-large style="width: 100%" class="btn btn-primary text-white" depressed
             v-if="book_accession && book_accession.id && book_accession.user_full_name" @click="returnBook"> Return
        Book
      </v-btn>
      <!--    </div>-->
      <!--    <div class="col-6">-->
      <v-btn x-large style="width: 100%" class="btn btn-primary text-white ml-2" depressed
             v-if="book_accession && book_accession.id && book_accession.is_available" @click="openDialog"> Issue Book
      </v-btn>
      <v-alert style="width: 100%" color="red" class="text-white text-center"
               v-if="book_accession && book_accession.id && !book_accession.user_full_name && !book_accession.is_available">
        This book cannot be issueable
      </v-alert>
    </div>
    <issue-book-modal ref="issue-book-modal" :dialog="issue_dialog" :setting="library_setting" @refresh="closeDialog('issue_dialog')"
                      :book_accession="book_accession"></issue-book-modal>

    <return-book-modal :dialog="cancel_and_return_dialog" :issue_list="selected_book" :user_id="book_accession.user_id"
                       @close_dialog="closeDialog('cancel_and_return_dialog')"
                       :library_setting="library_setting"></return-book-modal>
  </div>
</template>

<script>
import ReturnBookModal from "@/view/component/IssueRenewAndReturnModal/ReturnBookModal";
import IssueBookModal from "./IssueBookModal";

export default {
  name: "ReturnAndIssueByBookAccession",
  props: ['book_accession', 'library_setting'],
  components: {
    IssueBookModal, ReturnBookModal
  },
  data() {
    return {
      dialog: false,
      issue_dialog: false,
      cancel_and_return_dialog: false,
      selected_book: []
    }
  },
  methods: {
    openDialog(type) {
      this.issue_dialog = true;
    },
    closeDialog(type) {
      if (type == 'cancel_and_return_dialog')
        this.cancel_and_return_dialog = false
      else
        this.issue_dialog = false;
      this.$emit('refresh');
    },
    returnBook() {
      this.selected_book=[]
      this.selected_book.push(this.book_accession.issue_id)
      this.cancel_and_return_dialog = true
    }
  }
}
</script>

<style scoped>

</style>